export const isNotToday = (dateString) => {
  const today = new Date();
  const localTodayStr = today.toLocaleDateString('en-CA');

  return dateString !== localTodayStr;
};
